import { Injectable } from '@angular/core';

@Injectable()
export class EnvironmentServiceProvider {
    env: any = {};

    constructor(){
        const browserWindow = window || {};
        const browserWindowEnv = browserWindow['__env'] || {};

        // Assign environment variables from browser window to env
        // In the current implementation, properties from env.js overwrite defaults from the EnvService.
        // If needed, a deep merge can be performed here to merge properties instead of overwriting them.
        for (const key in browserWindowEnv) {
            if (browserWindowEnv.hasOwnProperty(key)) {
            this.env[key] = window['__env'][key];
            }
        }
    }

    get isCST () {
        return this.env.environment === 'Nebraska';
    }

    get oauthCodeFlowSettings() {
        return this.env.OAUTH_CODE_FLOW_SETTINGS;
    }
}


// WEBPACK FOOTER //
// ./src/providers/environment-service/environment-service.ts